import { type QueryKey, queryOptions, useQuery } from '@tanstack/react-query';
import { getCompany } from '../api/company.api';
import type { ICompany } from '../types';

export const companyQueryKey: QueryKey = ['current-company'];

export function useCompanyQuery(options: { onSuccess?: (company: ICompany) => void } = {}) {
  return useQuery({
    queryKey: companyQueryKey,
    queryFn: async () => {
      const { data } = await getCompany();
      options.onSuccess?.(data);

      return data;
    },
  });
}

export function getCompanyQuery() {
  return queryOptions({
    queryKey: companyQueryKey,
    queryFn: async () => (await getCompany()).data,
    staleTime: 1000 * 60 * 5,
  });
}
